import { all, fork } from 'redux-saga/effects'
import SupportSaga from './SupportSaga'

export default function* supportSagas() {
  yield all([fork(new SupportSaga().supervise)])
}
